"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserlandEmittedType = isUserlandEmittedType;
const NON_USERLAND_TYPES = [
    Array,
    BigInt,
    Boolean,
    Function,
    Number,
    Object,
    String,
];
function isUserlandEmittedType(type) {
    return !NON_USERLAND_TYPES.includes(type);
}
//# sourceMappingURL=isUserlandEmittedType.js.map